import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Translator from 'translator';
import { SvgTicket } from 'data/common/iconsvg';
import { Toastr } from 'data/common';
import { Grid } from '@material-ui/core';
import tools from 'data/common/tools';
import memoizeOne from 'memoize-one';
import {
    FHEContainer,
    FHEReactSelect,
    FHEContainerForm,
    FHEContainerScroll,
    FHETitle,
    FHETextField,
    FormEditButton,
    FormButtonContainer,
    FormButton
} from 'data/components';
import selectors from '../selectors';

class FormPushNotification extends Component {
    static propTypes = {
        pushNotificationId: PropTypes.string,
        getDetailsFunc: PropTypes.func,
        sendDataFunc: PropTypes.func.isRequired,
        sendEventFunc: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        saveRights: PropTypes.bool.isRequired,
        detailsRights: PropTypes.bool.isRequired,
        sendRights: PropTypes.bool.isRequired,
        updateRights: PropTypes.bool.isRequired,
        homes: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        homesArray: PropTypes.array.isRequired
    };

    static defaultProps = {
        pushNotificationId: null,
        getDetailsFunc: null
    };

    constructor(props) {
        super(props);
        const pushNotification = props.history.location.state && props.history.location.state.pushNotification;
        this.state = {
            pushNotification: pushNotification || {},
            formPushNotification: (props.type === 'add' || pushNotification) && this.getDataForm(pushNotification),
            formDisabled: props.type === 'update',
            textInput_error:
                props.history.location.state && props.history.location.state.eventError
                    ? { date: Translator.translate('generic.pushNotification.actions.sendPushNotificationErrorField') }
                    : {},
            sendLoading: false,
            loading: props.type === 'update' && !pushNotification,
            error: null
        };
        this.recipients = [
            {
                value: 'all',
                label: Translator.translate('generic.pushNotification.recipient.all')
            },
            {
                value: 'FR',
                label: Translator.translate('generic.pushNotification.recipient.FR')
            },
            {
                value: 'EN',
                label: Translator.translate('generic.pushNotification.recipient.EN')
            },
            {
                value: 'ES',
                label: Translator.translate('generic.pushNotification.recipient.ES')
            },
            {
                value: 'home_id',
                label: Translator.translate('generic.pushNotification.recipient.home_id')
            }
        ];
    }

    componentDidMount() {
        const { type, history } = this.props;
        if ((type === 'update' && !history.location.state) || (history.location.state && !history.location.state.pushNotification)) {
            this.getPushNotificationDetails();
        }
    }

    // tools
    getDataForm = pushNotification => {
        const { type } = this.props;

        return {
            title: type === 'update' ? pushNotification.title : null,
            body: type === 'update' ? pushNotification.body : null,
            recipient: type === 'update' ? pushNotification.recipient : null,
            homeIds: type === 'update' && pushNotification.recipient === 'home_id' ? pushNotification.homeIds : null
        };
    };

    getSelectedHomes = memoizeOne(homeIds => {
        const { homes } = this.props;

        if (homeIds) {
            return homeIds.reduce((reduction, value) => {
                const home = homes.getIn([value.toString()], new Map());
                return [...reduction, { value: value.toString(), label: home.get('label') }];
            }, []);
        }
    });

    getSelectedRecipient = memoizeOne(formRecipient => {
        return this.recipients.find(recipient => recipient.value === formRecipient);
    });

    navigateToDetail = (pushNotification, pushNotificationId) => {
        const { textInput_error } = this.state;
        const { history, detailsRights } = this.props;
        if (detailsRights)
            return history.push({
                pathname: `/fhe/push-notifications/detail/${pushNotificationId}`,
                state: { pushNotification, eventError: Object.keys(textInput_error).length > 0 }
            });
        return history.push(`/fhe/push-notifications`);
    };

    formatFormEvent = pushNotificationId => {
        const { match } = this.props;
        const { formPushNotification } = this.state;

        const formattedForm = {
            id: pushNotificationId || parseInt(match.params.pushNotificationId),
            title: formPushNotification.title,
            body: formPushNotification.body
        };

        if (formPushNotification.recipient === 'home_id') {
            formattedForm.homes = formPushNotification.homeIds;
        } else {
            formattedForm.topic = formPushNotification.recipient;
        }

        return formattedForm;
    };

    validateForm = form => {
        const arrayCheckEmptyFields = ['title', 'body', 'recipient'];
        if (form.recipient === 'home_id') arrayCheckEmptyFields.push('homeIds');
        const errors = tools.checkEmptyFields(form, arrayCheckEmptyFields);

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    handleChange = event => {
        const { formPushNotification, textInput_error } = this.state;
        const fieldLengthRules = {
            title: 50,
            body: 500
        };

        const value = tools.maxFieldLength(fieldLengthRules, formPushNotification, event.target);

        this.setState({
            formPushNotification: { ...formPushNotification, [event.target.name]: value },
            textInput_error: tools.removeKey(textInput_error, event.target.name)
        });
    };

    handleReactSelect = (event, options) => {
        const { formPushNotification, textInput_error } = this.state;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        if (options.name === 'recipient') {
            this.setState({
                formPushNotification: { ...formPushNotification, recipient: event.value },
                textInput_error: newTextInput_error
            });
        }

        if (options.name === 'homeIds') {
            this.setState({
                formPushNotification: {
                    ...formPushNotification,
                    homeIds: event ? event.map(home => home.value) : null
                },
                textInput_error: newTextInput_error
            });
        }
    };

    handleEdit = () => {
        const { formDisabled } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: !formDisabled,
            textInput_error: {}
        });
    };

    loadInputs = () => {
        const { pushNotification } = this.state;
        this.setState({
            formDisabled: true,
            formPushNotification: this.getDataForm(pushNotification)
        });
    };

    // calls
    getPushNotificationDetails = () => {
        const { getDetailsFunc, pushNotificationId } = this.props;
        this.setState({
            loading: true,
            error: null
        });
        getDetailsFunc(pushNotificationId)
            .then(pushNotification => {
                this.setState({
                    pushNotification,
                    formPushNotification: this.getDataForm(pushNotification),
                    loading: false
                });
            })
            .catch(error => {
                const message = Translator.translateWithFallback(`api.message.${error.message ? error.message : error}`, 'api.message.default');
                this.setState({
                    loading: false,
                    error: message
                });
            });
    };

    savePushNotification = () => {
        const { formPushNotification } = this.state;
        const { sendDataFunc, pushNotificationId, type } = this.props;

        this.setState({
            sendLoading: true,
            formDisabled: true
        });

        return sendDataFunc(formPushNotification, pushNotificationId).catch(error => {
            let errors = {};
            if (error.validation && error.validation.errors) {
                errors = tools.handleFormError(error.validation.errors);
                Toastr.error(Translator.translate(`generic.pushNotification.actions.${type}PushNotificationError`, formPushNotification.title));
            }
            this.setState({
                textInput_error: errors,
                sendLoading: false,
                formDisabled: false
            });
            throw error;
        });
    };

    sendEvent = pushNotificationId => {
        const { sendEventFunc } = this.props;
        const { pushNotification } = this.state;
        this.setState({
            sendLoading: true,
            textInput_error: {}
        });

        return sendEventFunc(this.formatFormEvent(pushNotificationId))
            .then(date => {
                this.setState({
                    pushNotification: { ...pushNotification, date },
                    sendLoading: false
                });
                return date;
            })
            .catch(e => {
                this.setState({
                    sendLoading: false,
                    textInput_error: { date: Translator.translate('generic.pushNotification.actions.sendPushNotificationErrorField') }
                });
                throw e;
            });
    };
    // handlers
    saveHandler = async () => {
        const { formPushNotification } = this.state;
        const { type } = this.props;

        if (!this.validateForm(formPushNotification)) return;

        this.savePushNotification()
            .then(data => {
                if (type === 'add') {
                    const { pushNotification, pushNotificationId } = data;
                    this.navigateToDetail(pushNotification, pushNotificationId);
                } else if (type === 'update') {
                    const pushNotification = data;
                    this.setState({
                        pushNotification,
                        formPushNotification: this.getDataForm(pushNotification),
                        formDisabled: true,
                        sendLoading: false
                    });
                }
                Toastr.success(
                    Translator.translate(`generic.pushNotification.actions.${type}PushNotificationSuccess`, formPushNotification.title),
                    Translator.translate(`generic.pushNotification.actions.${type}PushNotificationTitle`)
                );
            })
            .catch(() => {
                Toastr.error(
                    Translator.translate(`generic.pushNotification.actions.${type}PushNotificationError`, formPushNotification.title),
                    Translator.translate(`generic.pushNotification.actions.${type}PushNotificationTitle`)
                );
            });
    };

    sendEventHandler = () => {
        const { formDisabled, formPushNotification } = this.state;
        const { type } = this.props;

        if (!this.validateForm(formPushNotification)) return;
        // creation
        if (type === 'add') {
            this.savePushNotification()
                .then(data => {
                    let date = null;
                    this.sendEvent(data.pushNotificationId)
                        .then(successDate => {
                            Toastr.success(
                                Translator.translate('generic.pushNotification.actions.addAndSendSuccess', formPushNotification.title),
                                Translator.translate('generic.pushNotification.actions.sendNotificationTitle')
                            );
                            date = successDate;
                        })
                        .catch(() => {
                            Toastr.notice({
                                content: Translator.translate('generic.pushNotification.actions.addAndSendPartialError', formPushNotification.title),
                                title: Translator.translate('generic.pushNotification.actions.sendNotificationTitle')
                            });
                        })
                        .finally(() => this.navigateToDetail({ ...data.pushNotification, date }, data.pushNotificationId));
                })
                .catch(error => {
                    Toastr.error(
                        Translator.translateWithFallback(
                            `api.message.${error.message}`,
                            'generic.pushNotification.actions.addPushNotificationError',
                            formPushNotification.title
                        )
                    );
                });

            // Update
        } else if (type === 'update' && !formDisabled) {
            this.savePushNotification()
                .then(pushNotification => {
                    this.setState({
                        pushNotification,
                        formPushNotification: this.getDataForm(pushNotification),
                        formDisabled: true,
                        sendLoading: false
                    });

                    this.sendEvent()
                        .then(() => {
                            Toastr.success(
                                Translator.translate('generic.pushNotification.actions.updateAndSendSuccess', formPushNotification.title),
                                Translator.translate('generic.pushNotification.actions.sendNotificationTitle')
                            );
                        })
                        .catch(() => {
                            Toastr.notice({
                                content: Translator.translate(
                                    'generic.pushNotification.actions.updateAndSendPartialError',
                                    formPushNotification.title
                                ),
                                title: Translator.translate('generic.pushNotification.actions.sendNotificationTitle')
                            });
                        });
                })
                .catch(error => {
                    this.setState({
                        textInput_error: { date: Translator.translate('generic.pushNotification.actions.sendPushNotificationErrorField') }
                    });
                    Toastr.error(
                        Translator.translateWithFallback(
                            `api.message.${error.message}`,
                            'generic.pushNotification.actions.updatePushNotificationError',
                            formPushNotification.title
                        ),
                        Translator.translate('generic.pushNotification.actions.updatePushNotificationTitle')
                    );
                });

            // Send
        } else if (type === 'update' && formDisabled) {
            this.sendEvent()
                .then(() => {
                    Toastr.success(
                        Translator.translate('generic.pushNotification.actions.sendPushNotificationSuccess', formPushNotification.title),
                        Translator.translate('generic.pushNotification.actions.sendNotificationTitle')
                    );
                })
                .catch(() => {
                    Toastr.persistentError(
                        Translator.translate('generic.pushNotification.actions.sendPushNotificationError', formPushNotification.title),
                        Translator.translate('generic.pushNotification.actions.sendNotificationTitle')
                    );
                });
        }
    };

    confirmEventHandler = () => {
        const { type } = this.props;
        const { formDisabled } = this.state;

        const message =
            type === 'add'
                ? Translator.translate('generic.pushNotification.actions.addConfirmEventSending')
                : formDisabled
                ? Translator.translate('generic.pushNotification.actions.confirmEventSending')
                : Translator.translate('generic.pushNotification.actions.updateConfirmEventSending');

        Toastr.confirm(message, Translator.translate('generic.pushNotification.actions.sendNotificationTitle'), {
            onYes: () => this.sendEventHandler()
        });
    };

    // renders
    renderButtons = buttonsTypes => {
        const { formDisabled, sendLoading } = this.state;
        const { sendRights, updateRights, saveRights } = this.props;
        const array = [];
        buttonsTypes.forEach(btnType => {
            if (btnType === 'add' && saveRights) {
                array.push(<FormButton key="check" Icon="check" sendFunc={this.saveHandler} tooltipText={Translator.translate('general.save')} />);
            } else if (btnType === 'update' && updateRights) {
                array.push(
                    <FormEditButton
                        key="editButton"
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.saveHandler}
                        sendLoading={sendLoading}
                        positionClassName="none"
                    />
                );
            } else if (btnType === 'send' && sendRights) {
                array.push(
                    <FormButton
                        key="send"
                        Icon="send"
                        sendFunc={this.confirmEventHandler}
                        tooltipText={formDisabled ? Translator.translate('general.send') : Translator.translate('general.saveAndSend')}
                    />
                );
            }
        });
        return array;
    };

    renderChildren = () => {
        const { homesArray, type, updateRights, sendRights } = this.props;
        const { formPushNotification, textInput_error, formDisabled, sendLoading, pushNotification } = this.state;
        return (
            <Fragment>
                {type === 'add' ? (
                    <Fragment>
                        <FHETitle title={Translator.translate('general.addPushNotification')} Icon={SvgTicket} />
                        <FormButtonContainer sendLoading={sendLoading} buttons={this.renderButtons(['add', 'send'])} />
                    </Fragment>
                ) : (
                    <Fragment>
                        <FHETitle title={pushNotification ? pushNotification.title : ''} Icon={SvgTicket} />
                        {pushNotification && !pushNotification.date && (updateRights || sendRights) && (
                            <FormButtonContainer sendLoading={sendLoading} buttons={this.renderButtons(['update', 'send'])} />
                        )}
                    </Fragment>
                )}
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={12} lg={6}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="title"
                                    value={formPushNotification.title}
                                    error={textInput_error.title}
                                    label={Translator.translate('general.table.column.title')}
                                    name="title"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            {type === 'update' && (
                                <Grid container item sm={12} md={12} lg={6}>
                                    <FHETextField
                                        disabled
                                        id="date"
                                        value={
                                            pushNotification && pushNotification.date
                                                ? Translator.translate(`generic.pushNotification.status.sentAt`, pushNotification.date)
                                                : Translator.translate('generic.pushNotification.status.draft')
                                        }
                                        error={textInput_error.date}
                                        label={Translator.translate('general.table.column.status')}
                                        name="date"
                                    />
                                </Grid>
                            )}
                            <Grid container item sm={12} md={12} lg={12}>
                                <FHETextField
                                    multiline
                                    rows={5}
                                    rowsMax={10}
                                    disabled={formDisabled}
                                    id="body"
                                    value={formPushNotification.body}
                                    error={textInput_error.body}
                                    label={Translator.translate('general.table.column.body')}
                                    name="body"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={12} lg={4}>
                                <FHEReactSelect
                                    name="recipient"
                                    closeMenuOnSelect
                                    label={Translator.translate('general.table.column.recipient')}
                                    disabled={formDisabled}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedRecipient(formPushNotification.recipient)}
                                    choices={this.recipients}
                                    error={textInput_error.recipient}
                                />
                            </Grid>

                            {formPushNotification.recipient === 'home_id' && (
                                <Grid container item sm={12} md={12} lg={8}>
                                    <FHEReactSelect
                                        name="homeIds"
                                        label={Translator.translate('general.Homes')}
                                        placeholder={Translator.translate('generic.pushNotification.selectHome')}
                                        disabled={formDisabled}
                                        searchable
                                        onChange={this.handleReactSelect}
                                        multiple
                                        value={this.getSelectedHomes(formPushNotification.homeIds)}
                                        choices={homesArray}
                                        error={textInput_error.homeIds}
                                        closeMenuOnSelect={false}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </FHEContainerForm>
                </FHEContainerScroll>
            </Fragment>
        );
    };

    render() {
        const { loading, error } = this.state;
        return (
            <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getPushNotificationDetails} onRender={this.renderChildren} />
        );
    }
}

function mapStateToProps(state, props) {
    const profile = state.data.user;

    return {
        homes: selectors.getHomes(state),
        homesArray: selectors.getHomesArray(state),
        profile,
        detailsRights: profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('pushNotificationDetails'),
        saveRights: profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('pushNotificationAdd'),
        updateRights: profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('pushNotificationDetailsUpdate'),
        sendRights: profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('pushNotificationSend'),
        pushNotificationId: props.match.params.pushNotificationId
    };
}

export default withRouter(connect(mapStateToProps)(FormPushNotification));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/PushNotification/Form/FormPushNotification.js